import { takeLatest, all, put, call, race, delay } from "redux-saga/effects";
import { authClient } from '../../lib/auth';

import { authActionTypes } from "./auth.types";
import {
	updateSessionStatus,

	signUpSuccess,
	signUpFailure,

	signInSuccess,
	signInFailure,

	signOutSuccess,
	signOutFailure,

	forgotPasswordSuccess,
	forgotPasswordFailure,

	resetPasswordSuccess,
	resetPasswordFailure,
} from "./auth.actions";


export function* checkUserSession() {
	// null

	// {
	//     "session": {
	//         "id": "1IiajO70nIzxBzHMsmsnKbzfDtCntzZi",
	//         "expiresAt": "2025-03-07T15:11:34.000Z",
	//         "token": "nLPaweprFf6Hrtr3Znjz0wv07eC6ZhEL",
	//         "createdAt": "2025-03-04T15:11:34.000Z",
	//         "updatedAt": "2025-03-04T15:11:34.000Z",
	//         "ipAddress": "",
	//         "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36",
	//         "userId": "Jme2dea2dASaeiQyCaLlU668YSRVaPoN"
	//     },
	//     "user": {
	//         "id": "Jme2dea2dASaeiQyCaLlU668YSRVaPoN",
	//         "name": "tt@tt.tt",
	//         "email": "tt@tt.tt",
	//         "emailVerified": 0,
	//         "image": null,
	//         "createdAt": "2025-03-04T01:02:20.000Z",
	//         "updatedAt": "2025-03-04T01:02:20.000Z"
	//     }
	// }

	try {
		const { response, timeout } = yield race({
			response: call([authClient, authClient.getSession]),
			timeout: delay(5000), // 5 секунд
		});

		if (timeout) {
			// throw new Error('Запит перевищив ліміт часу');
			yield put(signInFailure(e));
		}

		const { data, error } = response;
		// const { data, error } = yield authClient.getSession();

		if (!data) {
			yield put(updateSessionStatus('not_authorized'));
		} else if (error) {
			yield put(signInFailure(error));
		} else {
			yield put(signInSuccess(data.user));
		}
	} catch (e) {
		yield put(signInFailure(e));
	}
}

export function* signUpEmail({ payload: { email, name, password } }) {
	try {
		// {
		// 	"token": "90CU7zZPdXaLwgTZViJTeqxqjwmB0dju",
		// 	"user": {
		// 		"id": "R9wGnegF40OfpxY1p42M05pVYvhlYhUw",
		// 		"email": "test.test@test.com",
		// 		"name": "test.test",
		// 		"image": null,
		// 		"emailVerified": 0,
		// 		"createdAt": "2025-02-28T06:17:54.000Z",
		// 		"updatedAt": "2025-02-28T06:17:54.000Z"
		// 	}
		// }

		// {
		// 	"message": "Failed to create user",
		// 	"details": {
		// 		"code": "ER_NO_DEFAULT_FOR_FIELD",
		// 		"errno": 1364,
		// 		"sqlState": "HY000",
		// 		"sqlMessage": "Field 'name' doesn't have a default value",
		// 		"sql": "insert into `user` (`id`, `email`, `emailVerified`, `createdAt`, `updatedAt`) values ('jRokwosRRlIg95B417jgNEPFGt0vbCvA', 'test.test@test.com', false, '2025-02-27 22:17:00.879', '2025-02-27 22:17:00.879')"
		// 	},
		// 	"code": "FAILED_TO_CREATE_USER",
		// 	"status": 422,
		// 	"statusText": "Unprocessable Entity"
		// }

		const { data, error } = yield authClient.signUp.email({ email, name, password });
		if (error) {
			yield put(signUpFailure(error));
		} else {
			yield put(signUpSuccess({ user: data.user }));
		}
	} catch (e) {
		yield put(signUpFailure(e));
	}
}

export function* signInEmail({ payload: { email, password } }) {
	// {
	// 	"redirect": false,
	// 	"token": "sxeoRRP2YeCSagZi6PbF0r9b8Bab5IDq",
	// 	"user": {
	// 		"id": "X6uIIYfOYqkTCZ2ua6xFXc3BGOhZ0pDD",
	// 		"email": "t@gmail.com",
	// 		"name": "t",
	// 		"image": null,
	// 		"emailVerified": 0,
	// 		"createdAt": "2025-02-28T07:00:59.000Z",
	// 		"updatedAt": "2025-02-28T07:00:59.000Z"
	// 	}
	// }

	// {
	// 	"message": "Invalid email or password",
	// 	"code": "INVALID_EMAIL_OR_PASSWORD",
	// 	"status": 401,
	// 	"statusText": "Unauthorized"
	// }

	try {
		const { data, error } = yield authClient.signIn.email({ email, password });
		if (error) {
			yield put(signInFailure(error));
		} else {
			yield put(signInSuccess(data.user));
		}
	} catch (e) {
		yield put(signInFailure(e));
	}
}

// export function* signInWithGoogle() {
// 	try {

// signIn.social({
// 	provider: "google",
//   })
// 		const { user } = yield auth.signInWithPopup(googleProvider);
// 		yield getSnapshotFromUserAuth(user);
// 	} catch (e) {
// 		yield put(signInFailure(e.message));
// 	}
// }

// export function* signInWithGithub() {
// 	try {

// signIn.social({
// 	provider: "github",
//   });

// 		const { user } = yield auth.signInWithPopup(googleProvider);
// 		yield getSnapshotFromUserAuth(user);
// 	} catch (e) {
// 		yield put(signInFailure(e.message));
// 	}
// }


export function* signOut() {
	try {
		const { error } = yield authClient.signOut();

		if (error) {
			yield put(signOutFailure(error));
		} else {
			yield put(signOutSuccess());
		}
	} catch (e) {
		yield put(signOutFailure(e.message));
	}
}


export function* forgotPassword({ payload: { email, redirectTo } }) {
	try {
		const { error } = yield authClient.forgetPassword({ email, redirectTo });

		if (error) {
			yield put(forgotPasswordFailure(error));
		} else {
			yield put(forgotPasswordSuccess());
		}
	} catch (e) {
		yield put(forgotPasswordFailure(e));
	}
}

export function* resetPassword({ payload: { newPassword, token } }) {
	try {
		const { status, error } = yield authClient.resetPassword({ newPassword, token });
		if (error) {
			yield put(resetPasswordFailure(error));
		} else {
			yield put(resetPasswordSuccess());
		}
	} catch (e) {
		yield put(resetPasswordFailure(e));
	}
}

// SESSION
export function* onCheckUserSession() {
	yield takeLatest(authActionTypes.CHECK_USER_SESSION, checkUserSession);
}

// SIGN UP: EMAIL
export function* onSignUpEmail() {
	yield takeLatest(authActionTypes.SIGN_UP_EMAIL_START, signUpEmail);
}

// SIGN IN: EMAIL
export function* onSignInEmail() {
	yield takeLatest(authActionTypes.SIGN_IN_EMAIL_START, signInEmail);
}

// // SIGN IN: GOOGLE
// export function* onSignInGoogleStart(){
// 	yield takeLatest(authActionTypes.SIGN_IN_GOOGLE_START, signInWithGoogle);
// }

// // SIGN IN: GITHUB
// export function* onSignInGithubStart(){
// 	yield takeLatest(authActionTypes.SIGN_IN_GITHUB_START, signInWithGoogle);
// }

// SIGN OUT
export function* onSignOutStart() {
	yield takeLatest(authActionTypes.SIGN_OUT_START, signOut);
}

// FORGOT PASSWORD
export function* onForgotPassword() {
	yield takeLatest(authActionTypes.FORGOT_PASSWORD_START, forgotPassword);
}

// RESET PASSWORD
export function* onResetPassword() {
	yield takeLatest(authActionTypes.RESET_PASSWORD_START, resetPassword);
}

export function* authSagas() {
	yield all
		([
			// SESSION
			call(onCheckUserSession),

			// SIGN UP
			call(onSignUpEmail),

			// SIGN IN
			call(onSignInEmail),
			// call(onSignInGoogleStart),
			// call(onSignInGithubStart),

			// SIGN OUT
			call(onSignOutStart),

			// FORGOT PASSWORD
			call(onForgotPassword),

			// RESET PASSWORD
			call(onResetPassword),
		]);
}